import { HashLink as Link } from "react-router-hash-link";
import React from "react";

function Contact() {
  const generalData = require("./../../datas/general.json");
  return (
    <div className="contact">
      <h1 ud="contact_title">Contactez-moi</h1>
      <div className="content">
        <div className="infodiv">
          <p>
            {generalData.info.name}
            <br />
            {generalData.info.phone}
            <br />
            {generalData.info.mail}
          </p>
          <div className="info_links">
            <a href={generalData.info.github.link} target="_blank" rel="noopener noreferrer">
              <img src={generalData.info.github.logo} alt="logo github" id="logo_github" />
            </a>
            <a href={generalData.info.linkedin.link} target="_blank" rel="noopener noreferrer">
              <img src={generalData.info.linkedin.logo} alt="logo linkedin" id="logo_linkedin" />
            </a>
          </div>
        </div>
      </div>
      <div id="linkhomediv">
        <Link smooth to="/pathLink#homezone" id="linkhome">
          Haut de page
        </Link>
      </div>
    </div>
  );
}

export default Contact;
